import DoAPICall from './DoAPICall'

//Create complaint sub type
export async function createSurveyQuestionListItem(userToken, SurveyQuestionListItem){
	const apiPayload = {
		httpMethod:'post',
		userToken,
		uri:'surveyquestionlistitems',
		payLoad:{
			survey_question_list_type_id:SurveyQuestionListItem.survey_question_list_type_id.toString(),
			value:SurveyQuestionListItem.value,
			order:SurveyQuestionListItem.order.toString()
		},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get All complaint sub type
export async function getSurveyQuestionListItems(userToken,survey_question_list_type_id){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'surveyquestionlistitems?survey_question_list_type_id='+survey_question_list_type_id,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get One complaint sub type
export async function getSurveyQuestionListItem(userToken, id){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'surveyquestionlistitems/'+id,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Update complaint sub type
export async function updateSurveyQuestionListItem(userToken, SurveyQuestionListItem){
	const apiPayload = {
		httpMethod:'put',
		userToken,
		uri:'surveyquestionlistitems/'+SurveyQuestionListItem.id,
		payLoad:{
				survey_question_list_type_id:SurveyQuestionListItem.survey_question_list_type_id,
				value:SurveyQuestionListItem.value,
				order:SurveyQuestionListItem.order.toString()
			},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Delete complaint sub type
export async function deleteSurveyQuestionListItem(userToken, id){
    const apiPayload = {
        httpMethod:'delete',
        userToken,
        uri:'surveyquestionlistitems/'+id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}